// @mui material components
import {Typography} from "@mui/material";
import Card from "@mui/material/Card";

//   React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import properties from "constants/ApplicationConstants";
import {formatEducation} from "constants/ApplicationConstants";
import {formatDate} from "constants/ApplicationConstants";
import dayjs from "dayjs";

// Billing page components
import Bill from "layouts/billing/components/Bill";
import {useState, useEffect} from "react";

function GeneralDetails({details = {}, noGutter}) {
  const [educationDisplay, setEducationDisplay] = useState("");
  useEffect(() => {
    if (details.education === "Other") {
      setEducationDisplay(details.educationOther || "");
    } else {
      setEducationDisplay(formatEducation(details.education));
    }
  }, [details.education, details.educationOther]);
  return (
    <MDBox pt={1} pb={0} px={2}>
      <MDBox pt={3} px={2}>
        <Typography variant="h6" fontWeight="bold" fontFamily={properties.fontFamily}>
          General Details
        </Typography>
      </MDBox>
      <MDBox component="ul" display="flex" flexDirection="column" p={0} m={0}>
        <Bill
          empId={details.empId}
          username={details.username}
          firstName={details.firstName}
          middleName={details.middleName}
          lastName={details.lastName}
          gender={details.gender}
          maritalStatus={details.maritalStatus}
          birthDate={formatDate(details.birthDate)}
          emailAddress={details.emailAddress}
          mobileNo={details.mobileNo}
          alterMobileNo={details.alterMobileNo}
          emergencyContact={details.emergencyContact}
          nameRelation={details.nameRelation}
          emergencyRelation={details.emergencyRelation}
          emegencyAddressLine1={details.emegencyAddressLine1}
          pfUanNo={details.pfUanNo}
          prevPfNo={details.prevPfNo}
          bntPfNo={details.bntPfNo}
          pancardNo={details.pancardNo}
          nameInPancard={details.nameInPancard}
          education={educationDisplay}
          speciallyAbled={
            details?.speciallyAbled === "1" || details?.speciallyAbled === "Yes"
              ? "Yes"
              : details?.speciallyAbled === "0" || details?.speciallyAbled === "No"
              ? "No"
              : ""
          }
          speciallyAbledCategory={
            details?.speciallyAbledCategory === "0" || details?.speciallyAbledCategory === "No"
              ? "No"
              : details?.speciallyAbledCategory || ""
          }
          fatherName={details.fatherName}
          noGutter
        />
      </MDBox>
    </MDBox>
  );
}

export default GeneralDetails;
